import React, { useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { orderBy } from "@progress/kendo-data-query";
import { MaskedTextBox } from "@progress/kendo-react-inputs";
import { AiOutlineSearch } from "react-icons/ai";
import { Input } from "@progress/kendo-react-inputs";

const initialSort = [
  {
    field: "row",
    dir: "asc",
  },
];

const initialDataState = {
  skip: 0,
  take: 6,
};

const voidRecord = [];

function SearchRequestGridContainer({ dataGrid, searchRegister }) {
  const [values, setValues] = useState(voidRecord);
  const [sort, setSort] = useState(initialSort);
  const [page, setPage] = useState(initialDataState);
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  const handleChange = useCallback(
    (e) => {
      if (e?.target?.value !== undefined) {
        const input = e.target.value.replace(/[^0-9]/g, "");
        setPhone(input);
      }
    },
    [setPhone]
  );

  useEffect(() => {
    if (dataGrid !== undefined) {
      setValues(dataGrid);
    }
  }, [dataGrid]);

  const pageChange = (event) => {
    setPage(event.page);
  };

  return (
    <>
      <div className="column justify-content-start mb-8">
        <div
          className="row justify-content-end flex-nowrap overflow-auto"
          style={{ marginRight: "auto" }}
        >
          <div div style={{ padding: "5px" }}>
            <Input
              value={phone}
              onChange={(event) => handleChange(event)}
              type="phone"
              placeholder="391234567890"
              style={{ maxWidth: "fit-content" }}
            />
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-cancel-command"
              style={{
                backgroundColor: "#007bff",
                color: "#fff",
                border: "1px solid #007bff",
                height: "fit-content",
                minWidth: "100px",
              }}
              onClick={() => searchRegister("Phone", phone)}
            >
              <AiOutlineSearch style={{ marginRight: "5px" }} />
              Telefono
            </button>
          </div>
        </div>
        <div
          className="row justify-content-end flex-nowrap overflow-auto"
          style={{ marginRight: "auto" }}
        >
          <div style={{ padding: "5px" }}>
            <Input
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              type="email"
              placeholder="example@domain.com"
              style={{ maxWidth: "fit-content" }}
            />
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-cancel-command"
              style={{
                backgroundColor: "#007bff",
                color: "#fff",
                border: "1px solid #007bff",
                minWidth: "100px",
              }}
              onClick={() => searchRegister("Email", email)}
            >
              <AiOutlineSearch
                style={{ marginRight: "5px", height: "fit-content" }}
              />
              Email
            </button>
          </div>
        </div>
      </div>
      <Grid
        style={{
          height: "fit-content",
        }}
        //data={dataGrid}
        //data={values}
        data={orderBy(values, sort)}
        skip={page.skip}
        take={page.take}
        total={0}
        pageable={false}
        pageSize={25}
        onPageChange={pageChange}
        resizable={true}
        sortable={true}
        sort={sort}
        onSortChange={(e) => {
          setSort(e.sort);
        }}
      >
        <Column field="row" title="Linea" width="auto" />
        <Column field="type" title="Tipo di oggetto di ricerca" width="auto" />
        <Column field="sourch" title="Oggetto di ricerca" width="auto" />
        <Column field="message" title="Messaggio" width="auto" />
      </Grid>
    </>
  );
}

export const SearchRequestGrid = connect(
  null,
  null
)(SearchRequestGridContainer);
